<template>
  <div class="content">
    <div class="user__fields-group">
      <div class="user__fields-group-list">
        <text-input
          class="user__fields-item"
          :title="$t('user-page.client_id')"
          view="line"
          v-model="userData.id"
          readonly
        ></text-input>
      </div>
    </div>
    <div class="user__fields-group">
      <div class="user__fields-group-title">
        {{ $t("user-page.registry_data") }}
      </div>
      <div class="user__fields-group-list">
        <text-input
          class="user__fields-item"
          :title="$t('user-page.full_name')"
          view="line"
          v-model="userDataEditable.full_name"
          :errors="v$.userDataEditable.full_name.$errors"
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.inn')"
          view="line"
          v-model="userDataEditable.inn"
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.certificate_number')"
          view="line"
          v-model="userDataEditable.certificate_number"
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.registry_identifier')"
          view="line"
          v-model="userDataEditable.registry_identifier"
          :errors="v$.userDataEditable.registry_identifier.$errors"
        ></text-input>
      </div>
    </div>
    <div class="user__fields-group">
      <div class="user__fields-group-title">
        {{ $t("user-page.contact_data") }}
      </div>
      <div class="user__fields-group-list">
        <text-input
          class="user__fields-item"
          :title="$t('user-page.phone')"
          view="line"
          v-model="userData.phone"
          readonly
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.phone_additional')"
          view="line"
          v-model="userDataEditable.phone_additional"
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.email')"
          view="line"
          v-model="userDataEditable.email"
          type="email"
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.notary_address')"
          view="line"
          v-model="userDataEditable.notary_address"
        ></text-input>
      </div>
    </div>
    <div class="user__fields-group">
      <div class="user__fields-group-title">
        {{ $t("user-page.requisites") }}
      </div>
      <div class="user__fields-group-list">
        <text-input
          class="user__fields-item"
          :title="$t('user-page.card_pan')"
          view="line"
          :mask="'#### #### #### ####'"
          v-model="userDataEditable.card_pan"
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.iban')"
          view="line"
          v-model="userDataEditable.iban"
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.okpo')"
          view="line"
          v-model="userDataEditable.okpo"
        ></text-input>
        <!-- TODO: Признак льготы          -->
        <text-input
          class="user__fields-item"
          :title="$t('user-page.exemption_date_finish')"
          view="line"
          mask="##.##.####"
          v-model="userDataEditable.exemption_date_finish"
        ></text-input>
      </div>
    </div>
    <div class="user__fields-group user__fields-group--dates">
      <div class="user__fields-group-list">
        <text-input
          class="user__fields-item"
          :title="$t('user-page.created_at')"
          view="line"
          :value="$moment(userData.created_at).format('DD.MM.yyyy')"
          readonly
        ></text-input>
        <text-input
          class="user__fields-item"
          :title="$t('user-page.updated_at')"
          view="line"
          :value="$moment(userData.updated_at).format('DD.MM.yyyy')"
          readonly
        ></text-input>
      </div>
    </div>
    <div class="user__actions">
      <primary-button
        :text="$t('user-page.save')"
        @click="saveProfile"
      ></primary-button>
    </div>
    <success-popup ref="successPopup" />
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { mapGetters, mapActions } from "vuex";
import { UserApi } from "@/office/user/user-api";
import SuccessPopup from "@/components/popup/SuccessPopup.vue";

export default {
  name: "UserNotaryCard",
  components: { PrimaryButton, TextInput, SuccessPopup },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      userDataEditable: {},
      showSuccessPopup: false,
    };
  },
  validations() {
    return {
      userDataEditable: {
        registry_identifier: {
          required: helpers.withMessage("phone_required", required),
        },
        full_name: {
          required: helpers.withMessage("full_name_required", required),
        },
      },
    };
  },
  created() {
    this.userDataEditable = this.prepareEditable(this.userData);
  },
  watch: {
    userData: function (newData) {
      this.userDataEditable = this.prepareEditable(newData);
    },
  },
  computed: {
    ...mapGetters(["userData"]),
  },
  methods: {
    ...mapActions(["LOAD_USER_DATA"]),

    prepareEditable(data) {
      return {
        ...data,
        exemption_date_finish: data.exemption_date_finish
            ? this.$moment(data.exemption_date_finish).format("DD.MM.YYYY")
            : "",
      };
    },

    async saveProfile() {
      const isValid = await this.v$.$validate;
      if (!isValid) return;

      const payload = {
        ...this.userDataEditable,
        exemption_date_finish: this.userDataEditable.exemption_date_finish
          ? this.$moment(
              this.userDataEditable.exemption_date_finish,
              "DD.MM.YYYY"
            ).format("YYYY-MM-DD")
          : null,
      };

      await new UserApi().saveUserData(payload);
      await this.LOAD_USER_DATA();
      this.$refs.successPopup.show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";
@import "~@/assets/scss/mixins";

.user__fields-group {
  margin-bottom: 25px;

  &--dates {
    margin-top: 60px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &-title {
    font-weight: bold;
    font-size: pxToRem(10);
    line-height: pxToRem(15);
    color: $textLight;
    margin-bottom: 15px;
  }

  &-list {
    padding-left: 40px;
  }
}

.user__fields-item {
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 0;
  }
}

.user__actions {
  margin-top: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
